import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Download, Search } from "lucide-react";

const formatBRL = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v) || 0);
const STATUS_CLASS = {
  approved:  "bg-[#E8F0E4] text-[#3E6A1E]",
  pending:   "bg-[#FFF8EE] text-[#7A5A1A]",
  in_process:"bg-[#FFF8EE] text-[#7A5A1A]",
  rejected:  "bg-[#F1E0DC] text-[#A8503B]",
  cancelled: "bg-[#F1E0DC] text-[#A8503B]",
  refunded:  "bg-[#F0E9DA] text-[#8C7B5E]",
};

export default function AdminSales() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/sales").then((r) => setRows(r.data || [])).finally(() => setLoading(false));
  }, []);

  const filtered = rows.filter((s) => {
    if (!q.trim()) return true;
    const nq = q.toLowerCase();
    return (
      (s.product_code || "").toLowerCase().includes(nq) ||
      (s.product_name || "").toLowerCase().includes(nq) ||
      (s.customer_name || "").toLowerCase().includes(nq) ||
      (s.customer_email || "").toLowerCase().includes(nq)
    );
  });

  const downloadCSV = async () => {
    const r = await api.get("/admin/sales/export.csv", { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "vendas_prize_joias.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-sales">
      <div className="flex items-center justify-between mb-8 gap-3 flex-wrap">
        <div>
          <p className="overline text-[#A8A8A8] mb-1">Financeiro</p>
          <h1 className="font-display text-4xl">Vendas</h1>
        </div>
        <button onClick={downloadCSV} className="btn-secondary inline-flex items-center" data-testid="admin-sales-export-btn">
          <Download size={14} className="mr-2"/> Exportar CSV
        </button>
      </div>

      <div className="mb-6 relative max-w-xl">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A8A8A8]"/>
        <input
          value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Pesquisar código, peça, nome do comprador ou e-mail…"
          className="input w-full pl-9"
          data-testid="admin-sales-search"
        />
      </div>

      {loading ? (
        <p className="text-[#A8A8A8]">Carregando…</p>
      ) : filtered.length === 0 ? (
        <p className="p-8 text-center text-[#A8A8A8] bg-white">Nenhuma venda registrada ainda.</p>
      ) : (
        <div className="bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#FAF9F7] text-left">
              <tr>
                <th className="p-4 overline text-[#A8A8A8]">Data</th>
                <th className="p-4 overline text-[#A8A8A8]">Código</th>
                <th className="p-4 overline text-[#A8A8A8]">Produto</th>
                <th className="p-4 overline text-[#A8A8A8]">Valor</th>
                <th className="p-4 overline text-[#A8A8A8]">Pagamento</th>
                <th className="p-4 overline text-[#A8A8A8]">Comprador</th>
                <th className="p-4 overline text-[#A8A8A8]">E-mail</th>
                <th className="p-4 overline text-[#A8A8A8]">Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((s) => (
                <tr key={s.id} className="border-t border-[#E8E4DF]" data-testid={`sale-row-${s.id}`}>
                  <td className="p-4 text-[#6B6B6B] whitespace-nowrap">{(s.created_at || "").replace("T", " ").slice(0, 16)}</td>
                  <td className="p-4 font-mono text-xs">{s.kind === "giftcard" ? "Gift Card" : (s.product_code || "—")}</td>
                  <td className="p-4">{s.product_name}</td>
                  <td className="p-4 whitespace-nowrap">{formatBRL(s.amount)}</td>
                  <td className="p-4 text-[#6B6B6B]">{s.payment_method_label}</td>
                  <td className="p-4">{s.customer_name}</td>
                  <td className="p-4 text-[#6B6B6B]">{s.customer_email}</td>
                  <td className="p-4">
                    <span className={`inline-block text-[10px] uppercase tracking-wider px-2 py-1 ${STATUS_CLASS[s.status] || "bg-[#F5EFE8]"}`}>
                      {s.status_label}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
